import React from "react";
import { Box, CircularProgress, useTheme } from "@mui/material";
import DonutChart from "./DonutChart";

export interface ChartDataItem {
    name: string;
    value: number;
    color: string;
}

export interface DonutChartDataProps {
    id?: string;
    data?: any; // API response data
    isLoading?: boolean;
    isFetching?: boolean;
    dataMapper: (data: any, theme: any) => ChartDataItem[];
}

/**
 * Generic DonutChart component that handles data fetching and mapping
 * @param id - Optional chart ID
 * @param data - API response data
 * @param isLoading - Loading state from query
 * @param isFetching - Fetching state from query
 * @param dataMapper - Function to map API data to chart format
 */
const DonutChartData: React.FC<DonutChartDataProps> = ({
    id,
    data,
    isLoading = false,
    isFetching = false,
    dataMapper,
}) => {
    const theme = useTheme();

    const chartData = React.useMemo(() => {
        if (!data) return [];
        return dataMapper(data, theme);
    }, [data, theme, dataMapper]);

    if (isLoading || isFetching) {
        return (
            <Box sx={{ textAlign: "center", py: 4 }}>
                <CircularProgress />
            </Box>
        );
    }

    return <DonutChart id={id} data={chartData} />;
};

export default DonutChartData;

